import { signOut } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import BackButtonImage from '../../assets/back-button.png';
import Logo from '../../assets/logo-dark.png';
import MusicalNotes from '../../assets/musical-notes.png';
import MusicalScore from '../../assets/musical-score.png';
import optionsButtonImage from '../../assets/options-button.png';
import Trophy from '../../assets/trophy.png';
import Options from '../../components/Options/Options';
import { auth } from '../../lib/firebase';
import { signOutUser } from '../../lib/firebase/Authentication/SignOut';
import Styles from './Classroom.module.css';

const Classroom = () => {
  const navigate = useNavigate();

  const [showOptions, setShowOptions] = useState(false);

  const toggleOptions = () => {
    setShowOptions((prev) => !prev);
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.log(err);
    }
  };
  const [isMobile, setIsMobile] = useState(false);

  // Check if user is on a mobile device
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android|iPad|iPhone|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, []);

  if (isMobile) {
    return (
      <div className={Styles.mobileMessage}>
        <h1>Mobile Version Coming Soon!</h1>
        <p>Please visit this site on a laptop or desktop.</p>
      </div>
    );
  }

  return (
    <div
      className={`${Styles.pageWrapper} ${
        showOptions ? Styles.darkerBackground : ''
      }`}
    >
      <div className={Styles.backgroundAnimation}>
        <div className={Styles.floatingNote1}>♪</div>
        <div className={Styles.floatingNote2}>♫</div>
        <div className={Styles.floatingNote3}>♪</div>
        <div className={Styles.floatingNote4}>♫</div>
      </div>

      <div className={Styles.header}>
        <div className={Styles.subButtonsContainer}>
          <button
            className={Styles.iconButton}
            onClick={() => signOutUser(navigate('/access'))}
          >
            <img src={BackButtonImage} alt="Back button" />
          </button>
          <button className={Styles.iconButton} onClick={toggleOptions}>
            <img src={optionsButtonImage} alt="Options button" />
          </button>
        </div>
      </div>

      {/* Main content area */}
      <div className={Styles.mainContent}>
        <div className={Styles.logoContainer}>
          <img className={Styles.logo} src={Logo} alt={'Website logo'} />
        </div>

        <div className={Styles.modesGrid}>
          <NavLink to="/classroom/classic" className={Styles.navLink}>
            <div className={Styles.modeCard}>
              <div className={Styles.cardIcon}>
                <img src={Trophy} />
              </div>
              <h2>Classic</h2>
              <div className={Styles.cardShine}></div>
            </div>
          </NavLink>

          <NavLink to={'/classroom/sandbox'} className={Styles.navLink}>
            <div className={Styles.modeCard}>
              <div className={Styles.cardIcon}>
                <img src={MusicalNotes} />
              </div>
              <h2>Sandbox</h2>
              <div className={Styles.cardShine}></div>
            </div>
          </NavLink>

          <NavLink to={'/classroom/scales'} className={Styles.navLink}>
            <div className={Styles.modeCard}>
              <div className={Styles.cardIcon}>
                <img src={MusicalScore} />
              </div>
              <h2>Scales</h2>
              <div className={Styles.cardShine}></div>
            </div>
          </NavLink>
        </div>
      </div>

      <div className={Styles.waveContainer}>
        <svg
          className={Styles.wave}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="#f4835e"
            fillOpacity="1"
            d="M0,288L24,261.3C48,235,96,181,144,176C192,171,240,213,288,218.7C336,224,384,192,432,202.7C480,213,528,267,576,272C624,277,672,235,720,234.7C768,235,816,277,864,256C912,235,960,149,1008,149.3C1056,149,1104,235,1152,250.7C1200,267,1248,213,1296,197.3C1344,181,1392,203,1416,213.3L1440,224L1440,320L1416,320C1392,320,1344,320,1296,320C1248,320,1200,320,1152,320C1104,320,1056,320,1008,320C960,320,912,320,864,320C816,320,768,320,720,320C672,320,624,320,576,320C528,320,480,320,432,320C384,320,336,320,288,320C240,320,192,320,144,320C96,320,48,320,24,320L0,320Z"
          ></path>
        </svg>
      </div>
      <div className={Styles.waveBottom}></div>

      {showOptions && <Options toggleOptions={toggleOptions} />}
    </div>
  );
};

export default Classroom;
